import { ccwpApi } from "@/services";
// Define a service using a base URL and expected endpoints

type GetFileImportProgressStatusRequestType = {
  importJobId: string;
};

export const ManualDataSourceApi = ccwpApi.injectEndpoints({
  endpoints: (builder) => ({
    listManualDataSource: builder.query<any, any>({
      query: (postData) =>({
        url:`ManualDataSource/ListManualDataSourceGrid`,
        params:{...postData}
      })
    }),
    createManualDataSource: builder.mutation<any, any>({
      query: (manualDataSourceData) => ({
        url: "/ManualDataSource/CreateManualDataSource",
        method: "POST",
        body: manualDataSourceData,
      }),
    }),
    getFileImportProgressStatus: builder.query<any, GetFileImportProgressStatusRequestType>({
      query: ({ importJobId }) =>
        `Import/GetFileImportProgressStatus?importJobId=${importJobId}`,
    }),
    downloadTemplateDocument: builder.query({
      query: ({ entityType,url,fileName = "downloaded_template",...args }) => ({
        url:url?url:"Document/DownloadTemplate",
        method: "GET",
        responseHandler: async (response) => {
          if (response?.status === 400) {
            console.log("error",response);
            return Promise.reject(response);
          }
          if(response?.status === 200){
          const url = URL.createObjectURL(await response.blob());
          const a = document.createElement("a");
          a.href = url;
          a.download = fileName;
          const downloadControls =
            document.getElementsByClassName("motif-modal-content")[0] ||
            document.body;
          downloadControls.appendChild(a);
          a.click();
          downloadControls.removeChild(a);
          URL.revokeObjectURL(url);
        }},
        transformResponse: (response: { results: any[] }) => response,
        params: { entityType,...args },
        cache: "no-cache",
      }),
    }),
    getManualDataSourceSummary: builder.query<any, string>({
      query: (manualDataSourceId) =>
        `ManualDataSource/GetManualDataSourceSummary?manualDataSourceId=${manualDataSourceId}`,
    }),
    updateManualSourceData: builder.mutation({
			query: (sourceData) => ({
				url: "ManualDataSource/UpdateManualDataSource",
				method: "PUT",
				body: sourceData,
			}),
		}),
    getListManualDataSourceUsage: builder.query<any, string>({
      query: (manualDataSourceId) =>
        `ManualDataSource/ListManualDataSourceUsage?manualDataSourceId=${manualDataSourceId}`,
    }),
    deleteManualDataSource: builder.mutation({
      query: (args) => ({
        url: `/ManualDataSource/DeleteManualDataSource`,
        method: "DELETE",
        params:{...args}
      }),
    }),
    downloadManualSourceDocument: builder.query({
      query: ({ manualDataSourceRecordId, fileName = "downloaded_file" }) => ({
        url: 'ManualDataSource/ExportManualDataSourceRecords',
        method: "GET",
        responseHandler: async (response) => {
          if(response?.status === 200){
            const url = URL.createObjectURL(await response.blob());
            const a = document.createElement("a");
            a.href = url;
            a.download = fileName;
            const downloadControls =
            document.getElementsByClassName("motif-modal-content")[0] ||
            document.body;
            downloadControls.appendChild(a);
            a.click();
            downloadControls.removeChild(a);
            URL.revokeObjectURL(url);
          }
        },
        params: { manualDataSourceRecordId },
        cache: "no-cache",
      }),
    }),
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useListManualDataSourceQuery,
  useCreateManualDataSourceMutation,
  useLazyGetFileImportProgressStatusQuery,
  useLazyDownloadTemplateDocumentQuery,
  useGetManualDataSourceSummaryQuery,
  useUpdateManualSourceDataMutation,
  useGetListManualDataSourceUsageQuery,
  useLazyDownloadManualSourceDocumentQuery,
  useDeleteManualDataSourceMutation
} = ManualDataSourceApi;
